import { render } from "./RecordCell.vue?vue&type=template&id=32150e8a&scoped=true"
import script from "./RecordCell.vue?vue&type=script&lang=js"
export * from "./RecordCell.vue?vue&type=script&lang=js"

import "./RecordCell.vue?vue&type=style&index=0&id=32150e8a&lang=scss&scoped=true"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32150e8a"]])

export default __exports__